import { useState } from "react";

import DialogBox from "components/layout/DialogBox";
import FunctionalButton from "components/layout/FunctionalButton";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import OrganizationMenu from "components/layout/navbar/OrganizationMenu";

import { setOrgId } from "lib/config";
import { useOrgId, useOrganizations } from "lib/hooks/useOrg";
import { logout } from "lib/orgServer/OrgServerClient";

// undefined = no popup; null = "New organization"; string = switch to that org.
type Pending = string | null | undefined;

const OrganizationSwitcher = () => {
    const organizations = useOrganizations();
    const currentOrg = useOrgId();
    const [pending, setPending] = useState<Pending>(undefined);

    const confirmSwitch = () => {
        // Pre-select the chosen org so the login screen shows it; a bare "New
        // organization" leaves the current org in place for the user to change.
        if (typeof pending === "string") setOrgId(pending);
        logout();
        window.location.reload();
    };

    const close = () => setPending(undefined);

    return (
        <>
            <OrganizationMenu
                currentOrg={currentOrg}
                organizations={organizations}
                onPickOrg={(org) => {
                    if (org !== currentOrg) setPending(org);
                }}
                footerLabel="New organization"
                onFooter={() => setPending(null)}
                buttonClassName="rounded-r5 bg-black90 px-3 py-1.5 text-h5 text-white"
            />
            <AnimatedModal visible={pending !== undefined} onClose={close}>
                <DialogBox
                    embedded
                    description="Switching organization will log you out."
                    onClose={close}
                    cancelButton={
                        <FunctionalButton
                            title="Cancel"
                            className="cancel-button"
                            onClick={close}
                        />
                    }
                    confirmButton={
                        <FunctionalButton
                            title="Log out"
                            className="confirm-button"
                            onClick={confirmSwitch}
                        />
                    }
                />
            </AnimatedModal>
        </>
    );
};

export default OrganizationSwitcher;
